import gql from 'graphql-tag'

export const ADD_CUSTOM_EXAM = gql`
  mutation adicionaProvaPersonalizada(
    $anos: [Int],
    $instituicoes: [String],
    $especialidades: [String],
    $dificuldades: [String],
    $quantidadeDePerguntas: Int,
    $perguntasAleatorias: Boolean,
    $respostasAleatorias: Boolean) {
    adicionaProvaPersonalizada(
      anos: $anos
      instituicoes: $instituicoes
      especialidades: $especialidades
      dificuldades: $dificuldades
      quantidadeDePerguntas: $quantidadeDePerguntas
      perguntasAleatorias: $perguntasAleatorias
      respostasAleatorias: $respostasAleatorias
      ) {
      _id
    }
  }
`

export const SUBMIT_EXAM_ANSWERS = gql`
  mutation adicionaResultadoProva(
    $prova_id: String,
    $tipo: String!,
    $perguntasRespondidas: [PerguntaRespondida]
    ) {
    adicionaResultadoProva(
      prova_id: $prova_id,
      tipo: $tipo,
      perguntasRespondidas: $perguntasRespondidas
      ) {
      _id
    }
  }
`